import React from 'react';
import './home.scss';
import logo from '../../img/LogoR3.png';
import logoQ from '../../img/LogoQuadrantisMedio.png';
import packageJson from '../../../package.json';

import {Logout, IsRole_Manager, IsRole_Operator, IsRole_OfficeAuditor} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 


//import { AuthProvider, useAuth } from '../../contexts/auth';
export default function Home() {

  //const authProvider = useAuth();
  //console.log(authProvider);

  const { user } = useAuth(); 

  if (!user) 
    Logout();
  else
  {
    //console.log('Token:' + user.token);
    console.log('Username:' + user.username);

    const isManager =IsRole_Manager();
    console.log('IsManager: ' + isManager);

    const isOperator=IsRole_Operator();
    console.log('IsOperator: ' + isOperator);

    const isOfficeAuditor=IsRole_OfficeAuditor();
    console.log('IsOfficeAuditor: ' + isOfficeAuditor);
  } 

  const appVersion = `${packageJson.version} ${packageJson.versionDate}`;

  return (
    <React.Fragment>

      <div className="content-block home-header">

        <img
          className="home-logo"
          src={logo}
          alt="RIBER Italia"
        />

        <div className="home-info">
          <div className="company-name">
            RIBER Italia Srl
          </div>

          <div className="company-address">
            Via S. Martino, 11 26900 Lodi (LO).
          </div>
        </div>

      </div>
      
      <div className={'content-block'}>

        <div className={'dx-card responsive-paddings'}>
         
          <div className={'logos-container'} >            
            <img
              alt={''}
              src={logoQ}
            />  
          </div>

          <small>Applicazione in <b>{process.env.NODE_ENV}</b> mode.</small>
          <p><small>Versione <b>{appVersion}</b></small></p>
            
        </div>

      </div>
      
    </React.Fragment>
)}
